import instance from "../utils/api_instance.util";
import { PACK_WRITE_TIMEOUT_MS } from "../utils/packApi.util.js";

export const fetchHuntPackListAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-hunt/fetchList", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const createHuntPackAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-hunt/create", { ...payload }, { timeout: PACK_WRITE_TIMEOUT_MS });
        return data;
    } catch (err) {
        throw err;
    }
};

export const updateHuntPackAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-hunt/update", { ...payload }, { timeout: PACK_WRITE_TIMEOUT_MS });
        return data;
    } catch (err) {
        throw err;
    }
};

export const updateHuntPackItemPositionsAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-hunt/updateItemPositions", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const changeHuntPackStatusAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-hunt/changeStatus", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const deleteHuntPackAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-hunt/delete", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};


export const huntPackDetailsById = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-hunt/fetchById", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const fetchHuntPackPurchaseStatsAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-hunt/purchaseStats", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const fetchHuntPackPurchaseHistoryAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-hunt/purchaseHistory", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};
